import { FC } from 'react'
import { Skeleton } from '@wellesley/ui'
import { AboutServerTabsSkeleton } from './components/AboutServerTabs/LoaderSkeleton'

export const LoaderSkeleton: FC = () => (
  <div className="mx-auto my-m h-screen max-h-[calc(100vh-40px)] w-screen max-w-[760px] rounded-lg bg-white p-m">
    <div className="flex flex-col items-center">
      <Skeleton className="mb-m h-xxs w-[138px] rounded-sm" />
      <Skeleton className="mb-m h-[160px] w-full rounded-xl" />
      <Skeleton className="h-[36px] w-[210px] self-start rounded-sm" />
      <div className="mb-xxs mt-xs flex w-full gap-xs">
        <Skeleton className="h-xxs w-[80px] rounded-sm" />
        <Skeleton className="h-xxs w-[80px] rounded-sm" />
      </div>
      <AboutServerTabsSkeleton />
    </div>
  </div>
)
